import { get } from "../../asignacion-horario/services/General.service";



const organizeData = (props) => {
    const { values, IdEmp, setAbleToSave, ip} = props;
    const mantener = ['Carnet', 'E_Nombres', 'E_Apellidos', 'GeneroEncargado', 'E_Direcc', 'E_Edad', 'E_EstadoCiv', 'E_DPI', 'E_TelCasa', 'E_Ocupa', 'E_TelTrab', 'NombreDoc', 'NitDoc', 'E_Cel2', 'EmailT',]
    const a = Object.keys(values).forEach(element => {
        console.log(element)
        if (!mantener.includes(element)){
            delete values[element]
        }else{
            if(!values[element]){
                // delete values[element]
                setAbleToSave(false)
                return "No data"
            }else{
                values[element] = values[element].toString()
            }
        }
    });
    
    values.Carnet = values.Carnet
    values.IdEmp = IdEmp
    values.HostName = "DEV07"
    values.IpHost = ip || "131.107.1.235"
    values.OS = "Windows"
    
    return values
    
}

const savedata = async (props) => {
    const {valores, setter, url, headers, api, setLoading} = props;
    console.log('valores: ', valores)
    let respuesta;
    try {
        setLoading(true)
        respuesta = await api(url, headers, valores)
        return respuesta
    } catch (error) {       
        console.log(error)
        setLoading(false)
    }
}

export { 
    organizeData,
    savedata,
};